import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FiCalendar, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSettings } from "../../../../context/settings";

const PRIORITY_CLASS = { High: 'high', Normal: 'medium', Medium: 'medium', Low: 'low' };

export function TaskCardContent({ task }) {
  const { t } = useTranslation();
  const { formatDate } = useSettings();
  const navigate = useNavigate();

  return (
    <div onClick={() => navigate(`/crm/tasks/view/${task.id}`, { state: {taskData: task} })}>
      <div className="task-card-subject">{task.subject}</div>
      <div className="task-meta">
        <FiUser size={12} />
        {task.customer}
      </div>
      <div className="task-card-footer">
        <span className={`priority-badge ${PRIORITY_CLASS[task.priority] || ''}`}>
          {task.priority}
        </span>
        <div className="task-meta" style={{ margin: 0 }}>
          <FiCalendar size={12} />
          {formatDate(task.due_date)}
        </div>
      </div>
      {task.description && (
        <div className="task-card-description">{task.description}</div>
      )}
    </div>
  );
}

export function TaskCard({ task }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: task.id });

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={`task-card${isDragging ? ' is-dragging' : ''}`}
      {...attributes}
      {...listeners}
    >
      <TaskCardContent task={task} />
    </div>
  );
}